// extracted by mini-css-extract-plugin
module.exports = {"fullWidthImage":"style_fullWidthImage__1-lI7","title":"style_title__1SbYc","image":"style_image__YNJ18"};